module.exports = "\n<div ng-if=\"$ctrl.guideCommand == 'PDF_VIEWER'\">\n    <div style=\"margin: 15px 30px\">\n      <h3 ng-show=\"$ctrl.nodeName\" style=\"text-align: center\">\n        {{$ctrl.title}} for {{$ctrl.nodeName}}</h3>\n    </div>\n    <iframe ng-src=\"{{$ctrl.urlGot | trusted}}\" width=\"90%\" height=\"650px;\" style=\"margin: 15px;\"></iframe>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/pdf-viewer/pdf-viewer.component.html
// module id = 729
// module chunks = 0